import { Api } from 'domain/core';
import { useEffect, useState } from 'react';
import { Alert, StationData } from 'domain/models';
import useFetch from 'domain/services/auth/fetch.service';
import { AlertDefinition } from 'domain/models/api.models';

export const useAlertPreview = (
	alertDefinition: AlertDefinition,
	config: { virtualStation?: number | string }
) => {
	const [stationData, setStationData] = useState<StationData[]>([]);
	const [alertData, setAlertData] = useState<Alert[]>([]);
	const [loading, setLoading] = useState<boolean>(false);

	const authFetch = useFetch();

	const load = async (): Promise<any> => {
		if (!config?.virtualStation) {
			return [];
		}
		setLoading(true);
		try {
			const response = await authFetch(
				`${Api.baseUrl}${Api.alerts.preview}?virtualStation=${
					config?.virtualStation ?? ''
				}`,
				{
					method: 'POST',
					body: JSON.stringify(alertDefinition),
				}
			);
			if (!response.ok) {
				throw new Error(response.statusText);
			}
			const data = await response.json();
			if (!data) {
				return [];
			}
			setStationData(data.data);
			setAlertData(data.alerts);
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (alertDefinition) {
			load();
		}
	}, [alertDefinition, config.virtualStation]);

	return {
		stationData,
		alertData,
		loading,
		load,
	};
};
